import { exhaustiveGuard } from '@libs/utils';

import { isFeatureToggleActive } from '../customFeatureToggles';

import type { StatsigExperimentName } from './statsigFeatureToggleTypes';

let isHotelDetailsRoomCardsGridLayoutExperiment = false;
let isNewSelectedRoomButtonExperiment = false;
let isNoTransportUpsellExperiment = false;
let isCancellationPoliciesInTripOverviewExperiment = false;
let isSummaryPaxClickabkeExperiment = false;

export function setExperimentValue(
  experimentName: StatsigExperimentName,
  value: boolean
): void {
  switch (experimentName) {
    case 'hotel_details_room_cards_grid_layout':
      isHotelDetailsRoomCardsGridLayoutExperiment = value;
      break;

    case 'new_rooms_button':
      isNewSelectedRoomButtonExperiment = value;
      break;

    case 'upsell_transport_in_itinerary':
      isNoTransportUpsellExperiment = value;
      break;

    case 'cancellation_policies_in_trip_overview':
      isCancellationPoliciesInTripOverviewExperiment = value;
      break;

    case 'clickable_pax_in_summary':
      isSummaryPaxClickabkeExperiment = value;
      break;

    default:
      exhaustiveGuard(experimentName, 'Invalid experiment name');
  }
}

function getExperimentValue(experimentName: StatsigExperimentName): boolean {
  switch (experimentName) {
    case 'hotel_details_room_cards_grid_layout':
      return isHotelDetailsRoomCardsGridLayoutExperiment;

    case 'new_rooms_button':
      return isNewSelectedRoomButtonExperiment;

    case 'upsell_transport_in_itinerary':
      return isNoTransportUpsellExperiment;

    case 'cancellation_policies_in_trip_overview':
      return isCancellationPoliciesInTripOverviewExperiment;

    case 'clickable_pax_in_summary':
      return isSummaryPaxClickabkeExperiment;

    default:
      exhaustiveGuard(experimentName, 'Invalid experiment name');
  }
}

export function isExperiment(experimentName: StatsigExperimentName): boolean {
  return (
    (getExperimentValue(experimentName) ||
      isFeatureToggleActive(experimentName)) &&
    !isFeatureToggleActive(`!${experimentName}`)
  );
}
